import { camelCase } from 'lodash'

import { UTILS__VALIDATOR__is_value } from '../../utils/validator'

export const USER__SET = obj => {
    return {
        type: 'USER__SET',
        payload: obj,
    }
}

export const USER__SET_DETAILS = obj => {
    return {
        type: 'USER__SET_DETAILS',
        payload: {
            id: obj.id,
            isTest: obj.isTest,
            email: obj.login,
            first_name: obj.firstName,
            last_name: obj.lastName,
            company: obj.company,
            news_subscription: obj.newsSubscription,
            roleInProjectDto: obj.roleInProjectDto,
            publicApiKey: obj.publicApiKey,
            avangateCustomerReference: obj.avangateCustomerReference,
            cid: obj.cid,
        },
    }
}

export const USER__UPDATE_DETAILS = obj => {
    let payload = {}

    if (UTILS__VALIDATOR__is_value(obj.id)) {
        payload.id = obj.id
    }
    if (UTILS__VALIDATOR__is_value(obj.email)) {
        payload.email = obj.email
    }
    if (UTILS__VALIDATOR__is_value(obj.first_name)) {
        payload.first_name = obj.first_name
    }
    if (UTILS__VALIDATOR__is_value(obj.company)) {
        payload.company = obj.company
    }
    if (UTILS__VALIDATOR__is_value(obj.last_name)) {
        payload.last_name = obj.last_name
    }
    if (UTILS__VALIDATOR__is_value(obj.news_subscription)) {
        payload.news_subscription = obj.news_subscription
    }

    return {
        type: 'USER__UPDATE_DETAILS',
        payload,
    }
}

export const USER__SET_SUBSCRIPTIONS = obj => ({
    type: 'USER__SET_SUBSCRIPTIONS',
    payload: obj,
})

export const USER__SET_SUBSCRIPTION = subscription => dispatch => {
    dispatch({
        type: 'USER__SET_SUBSCRIPTION',
        payload: subscription,
    })

    if (subscription) {
        const active_feature_product_list = Object.fromEntries(
            subscription.product.featureProducts.map(({ featureType }) => [featureType, true]),
        )

        dispatch({
            type: 'PROJECT_FEATURES__SET_LIST_OF_AVAILABLE',
            payload: active_feature_product_list,
        })
    }
}

export const USER__SET_SUBSCRIPTION_CONSTRAINTS = obj => {
    if (Array.isArray(obj)) {
        obj = Object.fromEntries(obj.map(datum => [camelCase(datum.featureProduct.featureType), datum]))
    }

    return {
        type: 'USER__SET_SUBSCRIPTION_CONSTRAINTS',
        payload: obj,
    }
}

export const USER__SET_NOTIFICATIONS = obj => ({
    type: 'USER__SET_NOTIFICATIONS',
    payload: obj,
})

export const USER__RESET_TRIAL = obj => ({
    type: 'USER__RESET_TRIAL',
    payload: obj,
})

export const USER__SET_TRIAL_COUNT = obj => ({
    type: 'USER__SET_TRIAL_COUNT',
    payload: obj,
})

export const USER__SET_NOTIFICATION_READ = obj => ({
    type: 'USER__SET_NOTIFICATION_READ',
    payload: obj,
})
